module.exports = __webpack_public_path__ + "static/media/Album 1.8553c453.png";